export default __webpack_public_path__ + "static/logosyndicat-40c45b06157b85cfd4ce21a64b012b49.png";